var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 24.75,
    viewBox: "0 0 36 24.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "drawer2",
    d: "M35.752,22.923l-9-11.25a1.125,1.125,0,0,0-.877-.423H10.125a1.118,1.118,0,0,0-.878.423l-9,11.25a1.125,1.125,0,0,0-.247.7V33.75A2.25,2.25,0,0,0,2.25,36h31.5A2.25,2.25,0,0,0,36,33.75V23.625a1.118,1.118,0,0,0-.247-.7Zm-2,1.827H25.875l-4.5,4.5h-6.75l-4.5-4.5H2.25v-.731L10.665,13.5H25.333l8.415,10.519v.731Z",
    transform: "translate(0 -11.25)",
    fill: "#818181"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.3fbab62b886d8935ff94fd2048f2de11.svg";
export { ForwardRef as ReactComponent };